/**
 * Created by maxkrasnov on 28.01.17.
 * version 1.0.0
 */


/**
 * класс Jamilco, включающий себя базовые методы для упрощения/ускорения разработки
 * @constructor - инициализируем необходимые объекты для работы
 */
function Jamilco() {
    // проверка подключения бутстрапа
    this._checkBootstrap3();

}

/**
 * вспомогательный метод, для проверки инициализации метода
 * @returns {boolean}
 */
Jamilco.prototype.isInit = function () {
    return true;
}

/**
 * метод для проверки подключения twitter bootstrap 3
 */
Jamilco.prototype._checkBootstrap3 = function () {
    if(typeof $().emulateTransitionEnd != 'function') {
        console.warn('Twitter Bootstrap 3 is not loaded. Recommend checked.');
    }
}

/**
 * метод для смены url браузера
 * @param url - нужный урл
 * @param param - удаление параметра, вида ajax=Y по дэфолту
 */
Jamilco.prototype.removeParamFromURL = function (url, param) {
    var title = $(document).find("title").text();
    if(!param) {
        param = 'ajax=Y';
    }
    url = url.replace(param, '');
    history.pushState('', title, url);

    if (typeof initLazy == 'function') initLazy();
}

/**
 * метод для добавления параметра в урл
 * @param url - сам урл
 * @param param - название параметра для добавления, типа param, в урле будет param=
 * @param value - значение параметра, типа value, в урле будет param=Y
 * @returns {string|*}
 */
Jamilco.prototype.addParamToURL = function(url, param, value) {
    (url.indexOf('?') == -1) ? url += '?' : url += '&';
    url += param + '=' + value;
    return url;
}


// init global
window.Jamilco = new Jamilco();

